

function Features(props) {
  return 'Features'
}
export default Features;